module.exports = __webpack_public_path__ + "img/ics_o_package-crrdon.995b4686.svg";